var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-tab", {
        attrs: {
          type: "vertical",
          tabItems: _vm.child.tabItems,
          height: _vm.tabHeight,
        },
        on: {
          "update:height": function ($event) {
            _vm.tabHeight = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (tab) {
              return [
                _c(tab.component, {
                  key: tab.key,
                  tag: "component",
                  attrs: {
                    patrol: _vm.patrol,
                    place: tab.place,
                    contentHeight: _vm.contentHeight,
                  },
                  on: {
                    "update:place": function ($event) {
                      return _vm.$set(tab, "place", $event)
                    },
                    tranStep: _vm.tranStep,
                    research: _vm.research,
                  },
                }),
              ]
            },
          },
        ]),
        model: {
          value: _vm.child.tab,
          callback: function ($$v) {
            _vm.$set(_vm.child, "tab", $$v)
          },
          expression: "child.tab",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }